import React, { useContext } from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
import { _getHomeUrl } from "../core/utils";
import HeaderDescriptionsSM from "./HeaderDescriptionsSM";
import { WrapperContext } from "./Layout";

const query = graphql`
  query {
    sanityHeader {
      descriptionLeft
      siteName
      descriptionRight
    }
  }
`;

const Header = () => {
  const { isHome } = useContext(WrapperContext);

  const { sanityHeader } = useStaticQuery(query);
  const { descriptionLeft, siteName, descriptionRight } = sanityHeader;

  return (
    <header className='fL' id='site-header'>
      <div className='top-header tac'>
        <h1 className='site-name'>
          <Link to={_getHomeUrl()}>{siteName}</Link>
        </h1>
      </div>
      <div className='descriptions'>
        <div className='hidden-sm'>
          <div className='row between-xs'>
            <div className='col-xs'>
              <div className='tal dib'>
                <div className='wsp ttu fSeg tac'>{descriptionLeft}</div>
              </div>
            </div>
            <div className='col-xs'>
              <div className='tar '>
                <div className='wsp dib ttu fSeg tac'>{descriptionRight}</div>
              </div>
            </div>
          </div>
        </div>
        {isHome && (
          <div className='sm-only'>
            <HeaderDescriptionsSM
              input={{ descriptionLeft, descriptionRight }}
            />
          </div>
        )}
      </div>

      {/* <Burger /> */}
    </header>
  );
};

export default Header;
